import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../components/breadCrumb";
import CheckBox from "../components/common/CheckBox";
import ComboBoxData from "../components/common/ComboBoxData";
import ComboBoxDataMulti from "../components/common/ComboBoxDataMulti";
import { NumericBox } from "../components/common/NumericBox";
import PageContent from "../components/pageContent";
import ProductBreadCrumb from "../components/products/ProductBreadCrumb";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { apiGetAllBasesByProduct } from "../services/BasesService";
import { apiGetAllColorsForSampleCard, apiGetAllColorsForSampleCardAndProductAndBase } from "../services/ColorsService";
import { apiGetAllProducts } from "../services/ProductsService";
import { apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { MultiSelect } from "react-multi-select-component";

import './KopirovaniRecepturPage.css';
import { TextBox } from "../components/common/TextBox";
import { apiCreateReceiptsCopyJob } from "../services/ReceiptsService";
import { TextArea } from "../components/common/TextArea";
import { useTranslation } from "react-i18next";

interface Props {
    contextLevel: string;

}

const KopirovaniRecepturPage = (props: Props) => {

    const { t } = useTranslation(undefined, { keyPrefix: 'CopyReceipts' });
    const { t: tComponentsMultiSelect } =
        useTranslation(undefined, { keyPrefix: 'General.Components.MultiSelect' });

    let initFormDataState: any =
    {
        'entireSampleCard': false, jobIdentifier: Math.floor(Math.random() * 1000),
        pigmentsRatio: 100, baseId: null, baseAmount: 1000,
        sampleCardId: null, colorIds: [], targetProductIds: [], targetProductsAsText: '',
        targetProductsIdsAsText: '',
        useCustomNote: false,
        customNote: '',
        useCustomPigmentsRatio: false,
        useCustomBaseAmount: false,
    };

    const [formData, setFormData] = useState(initFormDataState);
    const [basisForProduct, setBasisForProduct] = useState([]);
    const [sampleCardsForProduct, setSampleCardsForProduct] = useState([]);
    const [allTargetProducts, setAllTargetProducts] = useState([]);
    const [colorsForSampleCard, setColorsForSampleCards] = useState([]);
    const productInfo = useSelector((state: any) => state.productInfo);
    const dispatch = useDispatch();

    useEffect(() => {

        loadData(productInfo.productId);

    }, [productInfo]);

    const loadData = async (productId) => {

        var allBasis = await loadBasisForProduct(productId);
        let selectedBaseId: any = allBasis && allBasis.length > 0 ? allBasis[0].id : null
        var allSampleCards = await loadSampleCards(productId, selectedBaseId);


        var allProductsWithoutSelected = await loadProducts(productId);
        setFormData({
            ...formData,
            sampleCardId: allSampleCards && allSampleCards.length > 0 ? allSampleCards[0].id : null,
            baseId: selectedBaseId
        });
    }

    const loadBasisForProduct = async (productId) => {
        let bases = await apiGetAllBasesByProduct(productId);
        setBasisForProduct(bases.data);

        return bases.data;
    }

    const loadSampleCards = async (productId, baseId) => {

        let sampleCards = await apiGetSampleCardsForProduct(productId, false,false);
        setSampleCardsForProduct(sampleCards.data);

        if (sampleCards.data && sampleCards.data.length > 0) {
            loadColorsForSampleCard(null, sampleCards.data, baseId);
        }

        return sampleCards.data;
    }

    const loadColorsForSampleCard = async (sampleCardId, allSampleCards, baseId) => {

        let selectedSampleCardId = sampleCardId ?? allSampleCards[0].id;
        let colors = await apiGetAllColorsForSampleCardAndProductAndBase(selectedSampleCardId, productInfo.productId, baseId);
        setColorsForSampleCards(colors.data);

        return colors.data;
    }

    const loadProducts = async (productId) => {

        let allProducts = await apiGetAllProducts(false);
        let allProductsWithoutSelected = allProducts.data.filter(a => a.id != productId);

        setAllTargetProducts(allProductsWithoutSelected);
        return allProductsWithoutSelected;
    }

    const handleBaseChange = async (id) => {
debugger
        var colors = await loadColorsForSampleCard(formData.sampleCardId, null, formData.baseId);
        setFormData({ ...formData, baseId: id, colorId: (colors && colors.length > 0) ? colors[0].id : null });
    }

    const handleSampleCardChange = async (id) => {

        var colors = await loadColorsForSampleCard(id, null, formData.baseId);
        setFormData({ ...formData, sampleCardId: id, colorId: (colors && colors.length > 0) ? colors[0].id : null });


    }

    const handleColorChange = (ids) => {

        setFormData({ ...formData, colorIds: ids });
    }

    const handleTargetProductChange = (selectedOptions) => {

        let displayText = '';
        let idsAsText = '';

        if (selectedOptions && selectedOptions.length > 0) {
            let allSelectedLabels: any[] = [];
            let allSelectedIds: any[] = [];

            selectedOptions.forEach((option: any) => {
                allSelectedLabels.push(option.label);
                allSelectedIds.push(option.value);
            }
            );

            idsAsText = allSelectedIds.join('#');
            displayText = allSelectedLabels.join(', ');
        }

        setFormData({
            ...formData,
            targetProductIds: selectedOptions,
            targetProductsAsText: displayText,
            targetProductsIdsAsText: idsAsText
        });
    }


    const currentColorOptions = colorsForSampleCard.map((color: any) => {
        return { 'label': color.name, 'value': color.id }
    });

    const productsOptions = allTargetProducts.map((product: any) => {
        return { 'label': product.name, 'value': product.id }
    });

    return <>
        <PageContent>
            <>
                <ProductBreadCrumb selectionOfProductIsRequired={true} />
                <TopBarWithBreadCrumb
                    contextLevel={props.contextLevel}
                    pageLevel="Receptury"
                />

                <div className="row" style={{ padding: '20px' }}>
                    <div className="col-6">
                        <div className={`card`}>
                            <div className="card-header">
                                <h3 className="copyingSectionHeader">{t('SourceProduct')}</h3>
                            </div>
                            <div className="card-body">

                                <div className="row">
                                    <label className="col-sm-3 col-form-label zvlabel">
                                        {t('Product')}
                                    </label>
                                    <div className="col-sm-9" style={{ alignSelf: 'center', fontWeight: 500 }}>
                                        <span>{productInfo.productName}</span>
                                    </div>
                                </div>

                                <ComboBoxData
                                    id="basis"
                                    label={t('Basis')}
                                    dataTextField="name"
                                    dataValueField="id"
                                    value={formData.baseId}
                                    handleChange={handleBaseChange}
                                    rows={basisForProduct}
                                />

                                <CheckBox
                                    id="chkAllSampleCards"
                                    label={t('AllSampleCards')}
                                    paddingLeft={"10px"}
                                    handleCheckedChange={(checked) => {
                                        setFormData({ ...formData, allSampleCards: checked });
                                    }}
                                    defaultValue={formData.allSampleCards}
                                />

                                {!formData.allSampleCards && <>
                                    <ComboBoxData
                                        id="sampleCards"
                                        label={t('SampleCards')}
                                        dataTextField="name"
                                        dataValueField="id"
                                        value={formData.sampleCardId}
                                        handleChange={handleSampleCardChange}
                                        rows={sampleCardsForProduct}
                                    />

                                    <CheckBox
                                        id="chkEntireSampleCards"
                                        label={t('AllColors')}
                                        paddingLeft={"10px"}
                                        handleCheckedChange={(checked) => {
                                            setFormData({ ...formData, entireSampleCard: checked });
                                        }}
                                        defaultValue={formData.entireSampleCard}
                                    />

                                    {!formData.entireSampleCard &&
                                        <MultiSelect
                                            options={currentColorOptions}
                                            value={formData.colorIds}
                                            onChange={handleColorChange}
                                            labelledBy={t('Colors')}
                                            overrideStrings={{
                                                "allItemsAreSelected": tComponentsMultiSelect('allItemsAreSelected'),
                                                "clearSearch": tComponentsMultiSelect('clearSearch'),
                                                "clearSelected": tComponentsMultiSelect('clearSelected'),
                                                "noOptions": tComponentsMultiSelect('noOptions'),
                                                "search": tComponentsMultiSelect('search'),
                                                "selectAll": tComponentsMultiSelect('selectAll'),
                                                "selectAllFiltered": tComponentsMultiSelect('selectAllFiltered'),
                                                "selectSomeItems": tComponentsMultiSelect('selectSomeItems'),
                                                "create": tComponentsMultiSelect('create'),
                                            }}
                                        />}
                                </>}
                            </div>
                        </div>
                    </div>

                    <div className="col-6">

                        <div className={`card`}>
                            <div className="card-header">
                                <h3 className="copyingSectionHeader">{t('TargetProduct')}</h3>
                            </div>
                            <div className="card-body">

                                <MultiSelect
                                    options={productsOptions}
                                    value={formData.targetProductIds}
                                    onChange={handleTargetProductChange}
                                    labelledBy={t('Products')}
                                    overrideStrings={{
                                        "allItemsAreSelected": tComponentsMultiSelect('allItemsAreSelected'),
                                        "clearSearch": tComponentsMultiSelect('clearSearch'),
                                        "clearSelected": tComponentsMultiSelect('clearSelected'),
                                        "noOptions": tComponentsMultiSelect('noOptions'),
                                        "search": tComponentsMultiSelect('search'),
                                        "selectAll": tComponentsMultiSelect('selectAll'),
                                        "selectAllFiltered": tComponentsMultiSelect('selectAllFiltered'),
                                        "selectSomeItems": tComponentsMultiSelect('selectSomeItems'),
                                        "create": tComponentsMultiSelect('create'),
                                    }}
                                />

                                {formData.targetProductIds && formData.targetProductIds.length > 0 && <div style={{ marginBottom: '10px' }}>{formData.targetProductsAsText}</div>}
                                {!formData.targetProductIds || !formData.targetProductIds.length && <div style={{ textAlign: 'center', marginBottom: '10px' }}>Není vybrán žádný výrobek</div>}

                                <CheckBox
                                    id="chkCustomNote"
                                    label={t('CustomNote')}
                                    paddingLeft={"10px"}
                                    handleCheckedChange={(checked) => {
                                        setFormData({ ...formData, useCustomNote: checked });
                                    }}
                                    defaultValue={formData.useCustomNote}
                                />

                                {formData.useCustomNote &&
                                    <TextArea
                                        id="customNote"
                                        label={t('CustomNoteLabel')}
                                        placeholder={t('CustomNotePlaceHolder')}
                                        dataField="customNote"
                                        formData={formData}
                                        setStateMethod={setFormData}
                                        value={formData.customNote} rows={3}
                                    />}

                                {/*
                                <CheckBox
                                    id="chkCustomPigmentsRatio"
                                    label={t('CustomPigmentsRatio')}
                                    paddingLeft={"10px"}
                                    handleCheckedChange={(checked) => {
                                        setFormData({ ...formData, useCustomNote: checked });
                                    }}
                                    defaultValue={formData.useCustomNote}
                                />
                                */}

                                <NumericBox
                                    dataField="pigmentsRatio"
                                    defaultValue={formData.pigmentsRatio}
                                    formData={formData}
                                    setStateMethod={setFormData}
                                    id="pigmentsRatio"
                                    customLeftCols={'col-sm-3'}
                                    customRightCols={'col-sm-9'}
                                    label={t('PigmentsRatio')}
                                />

                                <NumericBox
                                    dataField="baseAmount"
                                    defaultValue={formData.baseAmount}
                                    formData={formData}
                                    setStateMethod={setFormData}
                                    id="baseAmount"
                                    customLeftCols={'col-sm-3'}
                                    customRightCols={'col-sm-9'}
                                    label={productInfo.productPrefersLitres ? t('BaseAmountMl') : t('BaseAmount')}
                                />
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row" style={{ padding: '20px', justifyContent: 'center' }}>
                    <div className="col-4" style={{ textAlign: 'center' }}>
                        <TextBox
                            id="jobIdentifier"
                            label={t('JobName')}
                            placeholder={t('JobNamePlaceHolder')}
                            dataField="jobIdentifier"
                            formData={formData}
                            setStateMethod={setFormData}
                            defaultValue={formData.jobIdentifier}
                            customLeftCols="col-sm-4"
                            customRightCols="col-sm-8"
                        />
                    </div>
                    <div className="col-4" style={{ textAlign: 'center' }}>
                        <button
                            style={{ width: '100%' }}
                            onClick={async () => {
                                debugger
                                let selectedBase: any = basisForProduct.filter((a: any) => a.id == formData.baseId);

                                if (!selectedBase || selectedBase.length == 0){
                                    alert(`Báze s id: ${formData.baseId} nebyla nalezena. Prosím kontaktujte podporu`);
                                    return;
                                }
                                var productIds = formData.targetProductIds.map(a => a.value);
                                var colorIds = formData.colorIds.map(a => a.value);

                                let response = await apiCreateReceiptsCopyJob({
                                    SourceProductId: productInfo.productId,
                                    SourceBaseId: formData.baseId,
                                    SourceBaseName: selectedBase[0].name,
                                    SourceSampleCardId: formData.sampleCardId,
                                    SourceColorIds: colorIds,
                                    AllSampleCards: formData.allSampleCards,
                                    AllColorsIncluded: formData.entireSampleCard,
                                    TargetProductIds: productIds,
                                    PigmentsRatio: formData.pigmentsRatio,
                                    JobIdentifier: formData.jobIdentifier.toString(),
                                    UseCustomNote: formData.useCustomNote,
                                    CustomNote: formData.customNote,
                                    BaseAmount: formData.baseAmount
                                });
                                if (response.status == 200) {
                                    try {
                                        let responseMessage = response?.data?.message;

                                        if (responseMessage &&
                                            responseMessage.length > 0) {
                                            if (responseMessage == 'Ok') {
                                                alert(t('JobReady'));
                                            }
                                            else {
                                                alert(`${t('JobNotReadyContactItWithMessage')} ${responseMessage}`);
                                            }

                                        }
                                        else {
                                            alert(t('JobNotReadyContactItGeneric'));
                                        }
                                    }
                                    catch {
                                        alert(t('JobNotReadyContactItGeneric'));
                                    }

                                }
                                else {
                                    alert(`${t('JobNotReadyContactItWithStatusCode')} ${response.status}`);
                                }
                            }}
                            type="button"
                            className="btn-sm btn-primary"
                        >
                            {t('Copy')}
                        </button>
                    </div>
                </div>

                <div className="row" style={{ padding: '20px' }}>
                    <div className="col-12" >
                        <div className={`card`}>
                            <div className="card-body">
                                <button
                                    style={{ width: '100%' }}
                                    onClick={async () => {

                                        window.location.replace(`/kopirovanirecepturjobstatus?jobIdentifier=${formData.jobIdentifier.toString()}`);
                                    }}
                                    type="button"
                                    className="btn-sm btn-primary"
                                >
                                    {t('ExecuteAndReport')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </PageContent>
    </>
}

export default KopirovaniRecepturPage;